/**
 * The cancellation-terms acknowledgment (mission 9 WP12 T075; sheet 08 callout 6; B.1; FR-003's client
 * half, FR-013, FR-023; spec amendment 10; contracts/ui-api.md "Sheet 08", "Accessibility").
 *
 * A labelled checkbox (style guide §7.3: 18px, the label in body text, never caption, the whole row
 * clickable) with `cancelTermsAck`: counsel's B6 sentence (memo 2026-10-03), one for both plans. B.1 has
 * the terms stated at purchase: the page keeps Subscribe disabled until this is ticked, and the checkout
 * sends the version of the terms shown (`terms.cancel_terms_version`), which the server records with the
 * subscription.
 */
import { useId } from 'react'

import { Checkbox } from '@/components/ui/checkbox'
import { PROVISIONAL_COPY } from '@/lib/provisional-copy'

export interface CancelTermsAckProps {
  annual: boolean
  checked: boolean
  onCheckedChange: (checked: boolean) => void
}

export function CancelTermsAck({ annual, checked, onCheckedChange }: CancelTermsAckProps) {
  const id = useId()
  return (
    <div className="flex items-start gap-2">
      <Checkbox id={id} className="mt-0.5" checked={checked} onCheckedChange={(next) => onCheckedChange(next === true)} />
      <label htmlFor={id} className="text-body text-navy-950">
        {PROVISIONAL_COPY.cancelTermsAck.render({ annual })}
      </label>
    </div>
  )
}
